var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiceBlue5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-552 -105) translate(48 105) translate(504)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "#7090FF",
    fillOpacity: 0.3,
    rx: 28
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 57,
    fill: "#7090FF",
    stroke: "#96ACF9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 79.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60.5,
    cy: 60.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 79.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 40.5,
    cy: 40.5,
    r: 8.5,
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 40.5,
    r: 8.5,
    fill: "#FFF"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceBlue5);
export default __webpack_public_path__ + "static/media/dice-blue-5.ec1687caff61059f28db276ca1afac6d.svg";
export { ForwardRef as ReactComponent };